export default {"src":"/_next/static/media/accidental_injuries.3fe50f33.svg","height":86,"width":88};